import React from "react";
import ServicePolicyPage from "components/misc/ServicePolicyPage";

export default function TermsOfService() {
  return <ServicePolicyPage type="terms" />;
}
